import { useEffect } from 'react';
import Layout from '../../components/public/Layout';
import { useAuth } from 'react-oidc-context';

const Logout = (): JSX.Element => {
  const { signoutRedirect } = useAuth();

  useEffect(() => {
    void signoutRedirect({
      post_logout_redirect_uri: `${window.location.origin}/signout`
    });
  }, [signoutRedirect]);

  const title = 'Logout user';

  return (
    <Layout
      title={title}
      forgotPassword={false}
      register={false}
      login={false}
      forgotPasswordLogin={false}
      loading={true}
    >
      <></>
    </Layout>
  );
};

export default Logout;
